<template>
  <div>
    <el-dialog
      top="10vh"
      width="700px"
      center
      :title="`银行卡「${reportHistoryObj.bankCardNumber}」上报历史 ( ${reportHistoryObj.id} ) `"
      :visible="reportHistoryObj.visible"
      @close="HandleCancel()"
    >
      <el-table
        border
        stripe
        ref="table"
        v-loading="listLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
      >
        <el-table-column label="时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="事件描述">
          <template slot-scope="scope">
            {{ scope.row.eventDescription }}
          </template>
        </el-table-column>
        <el-table-column label="操作员用户名">
          <template slot-scope="scope">
            {{ scope.row.operatorName }}
          </template>
        </el-table-column>
        <el-table-column label="扫脸线路">
          <template slot-scope="scope">
            {{ scope.row.faceScanRtspPk }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.phoneNumber }}
          </template>
        </el-table-column> -->
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.pageNum"
        :limit.sync="listQuery.pageSize"
        @pagination="getList()"
      />
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import { errorFeedbackHistory } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["reportHistoryObj"],
  data() {
    return {
      listLoading: false,
      dataList: [],
      total: 0,
      listQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
      },
    };
  },
  components: {
    Pagination,
  },
  watch: {
    reportHistoryObj(row) {
      if (row.visible) {
        this.getList();
      }
    },
  },
  methods: {
    HandleCancel() {
      this.$emit("update:report-history-obj", {});
    },
    getList() {
      this.listLoading = true;
      errorFeedbackHistory(this.reportHistoryObj.id, this.listQuery)
        .then((res) => {
          this.dataList = res.data.list;
          this.total = res.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/reportHistory.vue